<template>
  <div>
    <b-row>
      <b-col
        id="e-filtros"
        cols="12"
        md="12"
      >
        <!-- Filters -->
        <filters
          v-show="!errorContent.filters"
          :status-filter.sync="configRequest.status"
          :cuatri-filter.sync="configRequest.wsParams.cuatri"
          :plan-filter.sync="configRequest.wsParams.plan"
          :from-filter.sync="configRequest.wsParams.finicio"
          :status-options="OrdeneStatusOptions"
          :loader="loader.filters"
          :totalsolicitudes="(dataAux !== null && dataAux.length) ? dataAux.length : 0"
          :finicio.sync="configRequest.wsParams.finicio"
          @reloadApi="refetchData(true)"
        />
      </b-col>
    </b-row>

    <!-- tabla de ordenes  -->
    <b-overlay
      :show="isBusyTable"
      rounded="sm"
    >
      <!-- Tabla de ordenes -->
      <b-card
        v-show="!errorContent.table"
        no-body
        class="mb-0"
      >
        <transition name="fade-bottom">
          <section>
            <!-- Table Top -->
            <div class="m-2">
              <b-row>
                <!-- Cantidad de elementos por página -->
                <b-col
                  cols="12"
                  md="6"
                  class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                >
                  <span>Mostrar</span>
                  <v-select
                    id="e-page"
                    v-model="perPage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="perPageOptions"
                    :clearable="false"
                    class="per-page-selector d-inline-block mx-50"
                  />
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    class="btn-icon ml-1"
                    @click="detonante()"
                  >
                    <feather-icon icon="InfoIcon" />
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    v-b-toggle.sidebar-solicitudes
                    variant="outline-info"
                    class="btn-icon ml-1"
                  >
                    <feather-icon icon="HelpCircleIcon" />
                  </b-button>
                </b-col>
                <!-- Buscador -->
                <b-col
                  cols="12"
                  md="6"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <b-input-group
                      id="e-buscador"
                      class="input-group-merge"
                    >
                      <b-input-group-prepend is-text>
                        <feather-icon
                          :class="{ 'text-danger cursor-pointer': searchQuery != '' }"
                          :icon="searchQuery != '' ? 'XIcon' : 'SearchIcon'"
                          @click="searchQuery != '' ? searchQuery = '' : ''"
                        />
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="searchQuery"
                        :placeholder="(userRol.id != 1) ? 'Buscar nombre, referencia, matricula' : 'Escriba aqui'"
                      />
                    </b-input-group>
                  </div>
                </b-col>
              </b-row>
            </div>

            <!-- Table items -->
            <b-table
              id="e-listado"
              ref="refDataListTable"
              class="position-relative"
              :items="fetchData"
              :fields="tableColumns"
              responsive
              primary-key="id"
              :sort-by.sync="sortBy"
              show-empty
              empty-text="No se encontraron resultados, utilice los filtros."
              :sort-desc.sync="isSortDirDesc"
            >
              <!-- detalles tab -->
              <template #cell(show_details)="row">
                <b-form-checkbox
                  v-model="row.detailsShowing"
                  plain
                  class="vs-checkbox-con"
                  @change="row.toggleDetails"
                >
                  <span class="vs-checkbox">
                    <span class="vs-checkbox--check">
                      <i class="vs-icon feather icon-check" />
                    </span>
                  </span>
                  <span class="vs-label">{{ row.detailsShowing ? 'Ocultar' : 'Mostrar' }}</span>
                </b-form-checkbox>
              </template>
              <!-- detalle de row -->
              <template #row-details="row">
                <b-card>
                  <b-row class="mb-2">
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Aportacion : </strong>{{ row.item.precioFinal }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Descuento % : </strong>{{ row.item.codigo }} {{ row.item.descuento }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Beca : </strong>{{ row.item.abrev }} / {{ row.item.descripcion }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Registrado : </strong>{{ row.item.fecha }}
                    </b-col>
                    <b-col
                      md="8"
                      class="mb-1"
                    >
                      <strong>Observaciones : </strong>{{ row.item.observaciones }}
                    </b-col>
                  </b-row>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="row.toggleDetails"
                  >
                    Menos Detalles
                  </b-button>
                </b-card>
              </template>
              <!-- aportaciones -->
              <template #cell(pagos)="row">
                <b-badge :variant="frmAbonos(row.item).color">
                  <feather-icon
                    :icon="frmAbonos(row.item).icon"
                    class="mr-25"
                  />
                  {{ frmAbonos(row.item).text }}
                </b-badge>
              </template>
              <!-- matricula -->
              <template #cell(matricula)="row">
                <b-badge
                  :variant="(row.item.matricula != null) ? 'light-dark' : 'light-primary' "
                >
                  {{ (row.item.matricula != null) ? row.item.matricula : 'Inscripción' }}
                </b-badge>
              </template>
              <!-- status -->
              <template #cell(status)="row">
                <b-badge :variant="frmstatus(row.item.status).color">
                  {{ frmstatus(row.item.status).text }}
                </b-badge>
              </template>
              <!-- Column: descripcion/beca -->
              <template #cell(descripcion)="data">
                <b-media vertical-align="center">
                  <small>{{ (data.item.descripcion) ? data.item.abrev+' | '+data.item.descripcion : 'N/A' }}</small>
                </b-media>
              </template>
              <!-- registrado -->
              <template #cell(fecha)="data">
                <b-media vertical-align="center">
                  <small>{{ data.item.fecha }}</small>
                </b-media>
              </template>

              <!-- Column: Opciones -->
              <template #cell(opciones)="data">
                <div class="text-nowrap text-center">
                  <!-- Ver Orden -->
                  <b-link
                    class="font-weight-bold text-secondary"
                    :to="`/compras/${(userRol.id != 1) ? 'ordenes/preview' : 'preview'}/${shipcode(data.item.IdOrden)}/`"
                    @click="idAspiranteSelected = data.item"
                  >
                    <feather-icon
                      :id="`aspi-row-${data.item.IdOrden}-detalle-icon`"
                      icon="CoffeeIcon"
                      class="text-success cursor-pointer mr-1"
                      size="16"
                    />
                  </b-link>
                  <!-- cancelar una orden  -->
                  <feather-icon
                    v-show="data.item.status != 'AUT'"
                    :id="`list-row-${data.item.IdOrden}-reject-icon`"
                    icon="SlashIcon"
                    class="text-warning mr-1 cursor-pointer"
                    size="16"
                    @click="rejectOrden(data.item)"
                  />
                  <!-- link credenciales -->
                  <b-link
                    v-show="data.item.status == 'AUT' && data.item.persona_fk !== null"
                    class="font-weight-bold text-secondary"
                    @click="GetUrlCredenciales(data.item)"
                  >
                    <feather-icon
                      :id="`aspi-row-${data.item.IdOrden}-credenciales-icon`"
                      icon="KeyIcon"
                      class="text-warning cursor-pointer mr-1"
                      size="16"
                    />
                  </b-link>

                </div>
              </template>

            </b-table>

            <!-- Table's footer & pagination -->
            <div class="mx-2 mb-2">
              <b-row>
                <!-- Leyenda de cuantos elementos se muestran -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >

                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalItems"
                    :per-page="perPage"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>

                </b-col>
              </b-row>
            </div>
          </section>
        </transition>
      </b-card>
      <!-- sliders -->
      <side-bar-help-a
        id-sidebar="sidebar-solicitudes"
        :datos="insOrdeneslist"
      />
    </b-overlay>
    <!-- cancelar una solicitud/orden -->
    <b-modal
      v-model="flagreject"
      size="lg"
      title="¿Cancelar solicitud? - [ emite correo ]"
      no-body
      hide-footer
      @hide="flagreject = false"
    >
      <accion-cancelacion
        v-if="!isEmptyObject(setItem)"
        :orden="setItem.IdOrden"
        :open-modal.sync="flagreject"
        @reload-data="refetchData(true)"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BMedia,
  BPagination,
  BInputGroupPrepend,
  BFormInput,
  BLink,
  BOverlay,
  BBadge,
  // BAlert,
  BInputGroup,
  // BFormTextarea,
  BButton,
  // BSpinner,
  VBToggle,
  // BTooltip,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ref, onMounted, watch } from '@vue/composition-api'
import { lastUpdate, frmstatus, frmAbonos } from '@core/utils/filter'
import { isEmptyObject, formhttp, shipcode } from '@core/utils/utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import SideBarHelpA from '@/views/campus/components/compras/components/SideBarHelpA.vue'
import {
  useServicioEscolarCatalogos, configTableRequests,
} from '@/views/campus/components/compras/ConfigCompras'
import { rolesActions } from '@core/mixins/account-data/roles'
import { driver } from 'driver.js'
import { instructions } from '@/views/components/constantes'
import Filters from '../components/FiltersSE.vue'
import accionCancelacion from '../tareas/cancelar-orden.vue'
import 'driver.js/dist/driver.css'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BInputGroupPrepend,
    BFormInput,
    BLink,
    BPagination,
    vSelect,
    BOverlay,
    BBadge,
    Filters,
    // BAlert,
    BInputGroup,
    // BFormTextarea,
    BButton,
    // BSpinner,
    // BTooltip
    BFormCheckbox,
    accionCancelacion,
    SideBarHelpA,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  mixins: [rolesActions],
  setup() {
    const toast = useToast()
    const setItem = ref({})
    const { insOrdeneslist, drvRequestSE } = instructions()
    const updatedAt = ref(lastUpdate())
    const loader = ref({ filters: false })
    const errorContent = ref({ filters: false, table: false })
    const idAspiranteSelected = ref({})
    const { tableColumns, configRequest } = configTableRequests()
    const { planOptions, OrdeneStatusOptions, getRegCifrado } = useServicioEscolarCatalogos()
    const InfoPersona = ref({})
    const flagreject = ref(false)
    const flagproceder = ref(false)
    const driverObj = driver(drvRequestSE)
    const {
      //* Fetching data
      fetchData, refetchData, refDataListTable, dataAux,
      //* Pagination
      dataMeta,
      //* Table dynamic params
      dynamicParamRequest,
      //* Basic filters & pagination
      perPage, totalItems, currentPage, perPageOptions, searchQuery, sortBy, isSortDirDesc,
      //* Loader
      isBusyTable,
      //* Error
      errorRequest,
    } = useFillDataTable()
    isSortDirDesc.value = false

    const rejectOrden = obj => {
      // console.log(obj)
      setItem.value = obj
      flagreject.value = true
    }

    //* On mounted
    onMounted(() => {
      // configRequest.value.wsParams.finicio = '2023-01-01'
      dynamicParamRequest.value = configRequest.value
    })

    const GetUrlCredenciales = objorden => {
      if (objorden.persona_fk !== null) {
        getRegCifrado(objorden.persona_fk).then(response => {
          const { icon, label } = formhttp(response.status)
          if (response.status === 200) {
            const config = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes,width=700,height=800'
            const routeData = response.linkaccount
            window.open(routeData, 'Credenciales', config)
          }
          toast({
            component: ToastificationContent,
            props: {
              text: response.message,
              icon,
              variant: label,
            },
          })
        }, error => {
          toast({
            component: ToastificationContent,
            props: {
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 10000 })
        })
      }
    }

    watch(errorRequest, error => { if (error) errorContent.value.table = error }) //* If the flag 'errorRequest' from data request is true, hide table content

    // FILL DATOS FROM API
    watch([() => configRequest.value.wsParams.plan, () => configRequest.value.status], ([plan, status]) => {
      // console.log(`valores encontrados: ${plan}, config = ${status}`)
      if (plan != null && status == null) {
        // console.log(`Request API for plan: ${plan}`)
        refetchData(true) // call api
      } else if (status != null && plan != null) {
        // console.log(`Valor de configRequest: ${status}`)
        refetchData(false)
      } else if (plan == null && status == null) {
        // console.log('no tenemos plan ni estatus selecionado')
        refetchData(true) // seteamos vacia la lista
      }
    }, { immediate: true })

    // CONFIGURACION PARA PODER APLICAR UN FILTRO DE MANERA INICIAL
    // AL ARREGLO BASE DE API
    // watch(() => dataAux.value, value => {
    //   if (value !== null && value.length) {
    //     configRequest.value.status = 'ACT'
    //   }
    // })
    const detonante = () => {
      driverObj.drive()
    }

    return {
      fetchData,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      dataAux,
      setItem,
      insOrdeneslist,
      // Filter
      updatedAt,
      lastUpdate,
      // formTransac,
      // filter options
      OrdeneStatusOptions,
      planOptions,

      // Extra Filters
      idAspiranteSelected,
      isEmptyObject,

      // Extra Filters
      configRequest,

      // Loader
      loader,
      isBusyTable,

      // Error
      errorContent,
      // flags
      flagproceder,
      flagreject,
      rejectOrden,

      // tasks
      InfoPersona,
      frmstatus,
      frmAbonos,
      shipcode,
      GetUrlCredenciales,
      detonante,
      // reloadApi,
    }
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
